import {booleanAttribute, ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {DokumentId, EksternProtokollførtMøtedeltakerModell, ProtokollførtDeltakerstatus, ProtokollførtMøtedeltakerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {TranslateModule} from "@ngx-translate/core";
import {MøteModellDLM} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {MøteprotokollSignatarKomponent} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-signatar/møteprotokoll-signatar";

const debug = initDebugger('MøteprotokollSignatarerKomponent');

/**
 * Lister ut signatarer, med støtte for å utføre signering og vise signaturstatus dersom {@link #medSigneringsstoette() == true}.
 */
@Component({
    selector: 'moeteprotokoll-signatarer',
    templateUrl: 'møteprotokoll-signatarer.html',
    styleUrl: 'møteprotokoll-signatarer.scss',
    imports: [
        TranslateModule,
        MøteprotokollSignatarKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollSignatarerKomponent {

    /** Leverer event når bruker har signert */
    vedSignert = output<ProtokollførtMøtedeltakerModell>();

    signatarer = input.required<MøteprotokollSignatarer>();
    /** Dersom sann eksponeres funksjonalitet for å signere dersom bruker skal signere protokollen, ellers vises signaturinformasjon dersom bruker allerede har signert */
    medSigneringsstoette = input(false, {transform: booleanAttribute});
    /** Må angis dersom {@link #medSingeringsstoette() == true} */
    protokollDokumentId = input<DokumentId | null>();
    /** Må angis dersom {@link #medSingeringsstoette() == true} */
    moete = input<MøteModellDLM | null>();

    statuser = ProtokollførtDeltakerstatus;

    constructor() {
    }
}

export interface MøteprotokollSignatarer {
    interne: ProtokollførtMøtedeltakerModell[];
    eksterne: EksternSignatarer[];
}

export type EksternSignatarer = Pick<EksternProtokollførtMøtedeltakerModell, 'navn' | 'rolle' | 'kommentar'>;
